import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useQueryClient } from "react-query";

const LanguageListener = () => {
    const { i18n } = useTranslation();
    const queryClient = useQueryClient();

    useEffect(() => {
        queryClient.invalidateQueries();
    }, [i18n.language]);

    return null;
};

export default LanguageListener;